import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-532a4b0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "div-container" }
const _hoisted_2 = { class: "text-div" }
const _hoisted_3 = { class: "cost-div" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "counter-text-div"
}
const _hoisted_6 = {
  key: 1,
  class: "counter-button-div"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.cost), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dotPoints, (point) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "dot-point",
          key: point
        }, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(point), 1)
        ]))
      }), 128)),
      (_ctx.hasCounter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.counterText), 1))
        : _createCommentVNode("", true),
      (_ctx.hasCounter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "counter-button",
              disabled: _ctx.counter <= 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCounter(_ctx.counter - 1)))
            }, " - ", 8, _hoisted_7),
            _createElementVNode("input", {
              type: "number",
              class: "counter-input",
              min: "0",
              max: "999",
              value: _ctx.counter,
              onInput: _cache[1] || (_cache[1] = (event) => _ctx.setCounter(parseInt(event.target.value)))
            }, null, 40, _hoisted_8),
            _createElementVNode("button", {
              class: "counter-button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCounter(_ctx.counter + 1)))
            }, " + ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["rectangle-button", { red: _ctx.buttonRed }]),
      disabled: _ctx.buttonDisabled,
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onButtonClick(_ctx.counter)))
    }, _toDisplayString(_ctx.buttonTitle), 11, _hoisted_9)
  ]))
}